import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import html from "../assets/img/html.svg";
import css from "../assets/img/css.png";
import js from "../assets/img/js.png";
import bootstrap from "../assets/img/bootstrap.png";
import rjs from "../assets/img/react.png";
import mongo from "../assets/img/mongo.png";
import node from "../assets/img/node.png";
import exp from "../assets/img/express.png";
import git from "../assets/img/github.png";
import python from "../assets/img/python.png";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  const skills = [
    { img: html, title: "HTML5" },
    { img: css, title: "CSS3" },
    { img: js, title: "JavaScript" },
    { img: bootstrap, title: "Bootstrap" },
    { img: rjs, title: "ReactJS" },
    { img: mongo, title: "MongoDB" },
    { img: node, title: "NodeJS" },
    { img: exp, title: "Express" },
    { img: git, title: "GitHub" },
    { img: python, title: "Python" },
  ];

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>These are the technologies I've worked with in web development.</p>
              <Carousel
                responsive={responsive}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2500}
                className="owl-carousel owl-theme skill-slider"
              >
                {skills.map((skill, index) => (
                  <div className="item" key={index}>
                    <img src={skill.img} alt={`${skill.title} Logo`} />
                    <h5>{skill.title}</h5>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Background" />
    </section>
  );
};